import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import Context from "shared/util/Context";
import _str from "shared/util/_str";
import OnDOMReady from "shared/util/OnDOMReady";
import OkModal from "reflux/okmodal/app";
import OkModalManager from "reflux/okmodal/util/OkModalManager";
import OkPhotos from "shared/modules/OkPhotos";

import Messenger from "apps/messenger";
import store from "apps/messenger/store";
import {
	openConversation,
	closeConversation,
} from "ducks/global_messaging";
import { WINDOW_STATE } from "apps/messenger/util/consts";


// STATE
// ------------------------------

const _state = {
	isLoaded: false,
};

const PARENT_ID = "im_footer";
const TARGET_ID = "global_messaging_V2";


// LIB
// ------------------------------


const GlobalMessaging = {
	init() {
		this.render();
	},

	render() {
		// Already rendered, exit.
		if (_state.isLoaded) {
			return;
		}

		// Fetch the element to render into.
		const targetElement = this.getTarget();

		if (targetElement) {
			_state.isLoaded = true;

			render(
				<Provider store={store}>
					<Messenger />
				</Provider>,
				targetElement,
			);
		}
	},

	getTarget() {
		let target = document.getElementById(TARGET_ID);

		// Target doesn't exist yet, create it.
		if (!target) {
			const child = document.createElement("div");
			child.id = TARGET_ID;

			// Add the new element to the parent.
			const parent = document.getElementById(PARENT_ID);

			if (parent) {
				parent.appendChild(child);
				target = child;
			}
		}

		return target;
	},

	// These hooks are used by legacy non-React code,
	// and ideally should be removed some day.
	// (Do a search for "import GlobalMessaging")
	openConversation(userid, params = {}) {
		if (!_state.isLoaded) {
			this.init();
		}

		store.dispatch(openConversation(userid, params));
	},

	closeConversation(userid) {
		if (!_state.isLoaded) {
			this.init();
		}

		store.dispatch(closeConversation(userid));
	},

	isConversationOpen(userid) {
		// Something's not right here.
		if (!store || !store.getState || !store.getState().globalMessaging) {
			return false;
		}

		const {
			conversationOrder = [],
			conversationData = {},
		} = store.getState().globalMessaging;

		return conversationOrder.indexOf(userid) >= 0 && (
			conversationData[userid] && (
				conversationData[userid].state === WINDOW_STATE.Open
			)
		);
	},

	isConversationVisible(userid) {
		// Something's not right here.
		if (!store || !store.getState || !store.getState().globalMessaging) {
			return false;
		}

		const {
			conversationOrder = [],
			conversationData = {},
		} = store.getState().globalMessaging;

		return conversationOrder.indexOf(userid) >= 0 && (
			conversationData[userid] && (
				conversationData[userid].state === WINDOW_STATE.Open ||
				conversationData[userid].state === WINDOW_STATE.Minimized
			)
		);
	},

	isConversationOverflowed(userid) {
		// Something's not right here.
		if (!store || !store.getState || !store.getState().globalMessaging) {
			return false;
		}

		const {
			conversationOrder = [],
			conversationData = {},
		} = store.getState().globalMessaging;

		return conversationOrder.indexOf(userid) >= 0 && (
			conversationData[userid] && conversationData[userid].state === WINDOW_STATE.Overflow
		);
	},

	// Profile2015 controller needs this.
	// It's shown when the user doesn't have a photo
	// (and thus can't send any messages.)
	showPhotoBlock() {
		new OkModal({
			className: "OkModal-photoblocker",
			image: `${Context.get("cssImagePath")}media/img/okmodal-png/no_photo.png`,
			headline: _str("First, you need a photo"),
			body: _str("You can’t send messages until you add at least one photo of yourself."),
			ctaText: _str("Add your photo"),
			dismissText: _str("Nah, I’ll talk to myself"),

			onAction(e) {
				e.preventDefault();
				OkModalManager.closeAll();
				OkPhotos.init();
			},
		});
	},
};

export default GlobalMessaging;

// EXPORT
// ------------------------------

OnDOMReady(() => {
	GlobalMessaging.init();
});



// WEBPACK FOOTER //
// ./src/features/global_messaging/index.js